<form
  *ngIf="generalForm"
  class="field-dialog__content__scroll p-24"
  fxLayout="column"
  name="form"
  [formGroup]="generalForm"
  fusePerfectScrollbar
>
  <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start center">
    <mat-form-field appearance="legacy" fxFlex="100">
      <mat-label>{{ 'SEGMENTS.HEADER.NAME' | translate }}</mat-label>
      <input matInput formControlName="name" required />

      <mat-error *ngIf="generalForm.get('name').hasError('required')">
        {{ 'SEGMENTS.ERRORS.NAME_REQUIRED' | translate }}
      </mat-error>

      <mat-error *ngIf="generalForm.get('name').hasError('segment_name_duplicated')">
        {{ 'SEGMENTS.ERRORS.NAME_DUPLICATED' | translate }}
      </mat-error>
    </mat-form-field>
  </div>
</form>
